import Dashboard from '@/agilis/components/Dashboard/Dashboard.vue'
import Configuration from '@/agilis/util/Configuration'

import Vue from 'vue'

const dashboard = `{
  "metrics":
  {
      "default":
      {
          "query": "applicationPropositions"
      },
      "totOpportunities":
      {
          "id": "totOpportunities",
          "name": "sales.dashboard.totOpportunities",
          "icon": "mdi-lightbulb-on",
          "type": "counter",
          "formula": {
              "jsonLogic": {"==": [{ "var": "trackerTypeId" }, "opportunity"]}
          },
          "query": "applicationTrackers"
      },
      "totInProgressProposition":
      {
          "id": "totInProgressProposition",
          "name": "sales.dashboard.totInProgressProposition",
          "icon": "mdi-progress-pencil",
          "type": "counter",
          "formula": {
              "jsonLogic": {"==": [{ "var": "state" }, "InProgress"]}
          },
          "style": {
              "backgroundColor": {
                  "jsonLogic": {
                      "if":
                      [
                          { ">=" : [{ "var": "result" }, 10]},
                          "yellow lighten-5",
                          ""
                      ]
                  }
              }
          }
      },
      "totSolutionDefinedProposition":
      {
          "id": "totSolutionDefinedProposition",
          "name": "sales.dashboard.totSolutionDefinedProposition",
          "icon": "mdi-check-bold",
          "type": "counter",
          "formula": {
              "jsonLogic": {"==": [{ "var": "state" }, "SolutionDefined"]}
          }
      },
      "totVerifyOfferProposition":
      {
          "id": "totVerifyOfferProposition",
          "name": "sales.dashboard.totVerifyOfferProposition",
          "icon": "mdi-magnify-expand",
          "type": "counter",
          "formula": {
              "jsonLogic": {"==": [{ "var": "state" }, "VerifyOffer"]}
          }
      },
      "totOfferReadyProposition":
      {
          "id": "totOfferReadyProposition",
          "name": "sales.dashboard.totOfferReadyProposition",
          "icon": "mdi-bank-check",
          "type": "counter",
          "formula": {
              "jsonLogic": {"==": [{ "var": "state" }, "OfferReady"]}
          }
      },
      "totValidationRequiredProposition":
      {
          "id": "totValidationRequiredProposition",
          "name": "sales.dashboard.totValidationRequiredProposition",
          "type": "counter",
          "formula": {
              "jsonLogic": {"==": [{ "var": "state" }, "ValidationRequired"]}
          }
      },
      "totAcceptedSalesProposition":
      {
          "id": "totAcceptedSalesProposition",
          "name": "sales.dashboard.totAcceptedSalesProposition",
          "icon": "mdi-account-check",
          "type": "counter",
          "formula": {
              "jsonLogic": {"==": [{ "var": "state" }, "AcceptedSales"]}
          }
      },
      "totAcceptedCustomerProposition":
      {
          "id": "totAcceptedCustomerProposition",
          "name": "sales.dashboard.totAcceptedCustomerProposition",
          "icon": "mdi-handshake-outline",
          "type": "counter",
          "formula": {
              "jsonLogic": {"==": [{ "var": "state" }, "AcceptedCustomer"]}
          }
      },
      "totRefusedCustomerProposition":
      {
          "id": "totRefusedCustomerProposition",
          "name": "sales.dashboard.totRefusedCustomerProposition",
          "icon": "mdi-account-cancel",
          "type": "counter",
          "formula": {
              "jsonLogic": {"==": [{ "var": "state" }, "RefusedCustomer"]}
          }
      },
      "totCancelledProposition":
      {
          "id": "totCancelledProposition",
          "name": "sales.dashboard.totCancelledProposition",
          "icon": "mdi-cancel",
          "type": "counter",
          "formula": {
              "jsonLogic": {"==": [{ "var": "state" }, "Cancelled"]}
          }
      },
      "totExpiringProposition":
      {
          "id": "totExpiringProposition",
          "name": "sales.dashboard.totExpiringProposition",
          "icon": "mdi-timeline-clock",
          "type": "counter",
          "formula": {
              "jsonLogic":
              {
                  "and":
                  [
                      {"!!": [{"var": "endDate"}]},
                      {"<=" : [
                          0,
                          { "momentDiff": [{"var": "endDate"}, "todayBOD", "days"] },
                          5
                      ]}
                  ]
              }
          },
          "style": {
              "backgroundColor": {
                  "jsonLogic": {
                      "if":
                      [
                          { ">=" : [{ "var": "result" }, 1]},
                          "red lighten-5",
                          ""
                      ]
                  }
              }
          }
      },
      "expiringPropositionTable":
      {
          "id": "expiringPropositionTable",
          "name": "sales.dashboard.expiringPropositionTable",
          "type": "table",
          "formula": {
              "jsonLogic":
              {
                  "and":
                  [
                      {"!!": [{"var": "endDate"}]},
                      {"<=" : [
                          0,
                          { "momentDiff": [{"var": "endDate"}, "todayBOD", "days"] },
                          5
                      ]}
                  ]
              }
          }
      }
  },

  "layoutElements": {
      "titleOpportunity": {
          "type": "title",
          "label": "sales.dashboard.opportunity"
      },
      "titleProposition": {
          "type": "title",
          "label": "sales.dashboard.proposition"
      }
  },

  "layout":
  [
      {"cols": ["titleOpportunity"]},
      {"cols": ["totOpportunities", "", "", ""]},
      {"cols": ["titleProposition"]},
      {"cols": ["totInProgressProposition", "totSolutionDefinedProposition", "totVerifyOfferProposition", "totOfferReadyProposition"]},
      {"cols": ["totAcceptedCustomerProposition", "totAcceptedSalesProposition", "totRefusedCustomerProposition", "totExpiringProposition"]},
      {"cols": ["expiringPropositionTable"]}
  ]
}`

const query = `{
  "applicationTrackers":
  {
      "id": "applicationTrackers",
      "sql":
      [
          "select id, title, state, endDate, applicationId, trackerTypeId, workspaceId ",
          "from agilis_sales.agilis_tracker t "
      ],
      "dataTable":
      {
          "columns":
          {
              "id":
              {
                  "id": "id",
                  "type": "number"
              },
              "title":
              {
                  "id": "title",
                  "type": "string"
              },
              "state":
              {
                 "id": "state",
                 "label": "status",
                 "type": "string",
                 "renderMethod": "renderState"
              },
              "endDate":
              {
                 "id": "endDate",
                 "type": "date"
              },
              "applicationId":
              {
                  "id": "applicationId",
                  "type": "string",
                  "header": false
              },
              "trackerTypeId":
              {
                  "id": "trackerTypeId",
                  "type": "string",
                  "header": false
              },
              "workspaceId":
              {
                  "id": "workspaceId",
                  "type": "string",
                  "header": false
              }
          }
      }
  },
  "applicationPropositions":
  {
      "id": "applicationPropositions",
      "sql":
      [
          "select id, title, state, endDate, applicationId, trackerTypeId, workspaceId ",
          "from agilis_sales.agilis_tracker t ",
          "where t.trackerTypeId = 'proposition'"
      ],
      "dataTable":
      {
          "columns":
          {
              "id":
              {
                  "id": "id",
                  "type": "number"
              },
              "title":
              {
                  "id": "title",
                  "type": "string"
              },
              "state":
              {
                 "id": "state",
                 "label": "status",
                 "type": "string",
                 "renderMethod": "renderState"
              },
              "endDate":
              {
                 "id": "endDate",
                 "type": "date"
              },
              "applicationId":
              {
                  "id": "applicationId",
                  "type": "string",
                  "header": false
              },
              "trackerTypeId":
              {
                  "id": "trackerTypeId",
                  "type": "string",
                  "header": false
              },
              "workspaceId":
              {
                  "id": "workspaceId",
                  "type": "string",
                  "header": false
              }
          }
      }
  }
}`

const results = `{
  "applicationTrackers": [
    { "id": "1", "trackerTypeId": "opportunity" },
    { "id": "2", "trackerTypeId": "opportunity" },
    { "id": "3", "trackerTypeId": "opportunity" },
    { "id": "4", "trackerTypeId": "opportunity" },
    { "id": "5", "trackerTypeId": "opportunity" },
    { "id": "6", "trackerTypeId": "task" },
    { "id": "7", "trackerTypeId": "task" },
    { "id": "8", "trackerTypeId": "task" },
    { "id": "9", "trackerTypeId": "task" }
  ],
  "applicationPropositions": [
    { "id": "1", "state": "InProgress" },
    { "id": "2", "state": "InProgress" },
    { "id": "3", "state": "InProgress" },
    { "id": "4", "state": "InProgress" },
    { "id": "5", "state": "InProgress" },
    { "id": "6", "state": "InProgress" },
    { "id": "7", "state": "InProgress" },
    { "id": "8", "state": "InProgress" },
    { "id": "9", "state": "InProgress" }
  ]
}`

export default {
  name: 'PlaygroundDashboard',

  components: {
    Dashboard
  },

  data () {
    return {
      dashboard: JSON.parse(dashboard),
      dashboardAsString: dashboard,
      results: JSON.parse(results),
      resultsAsString: results,
      invalidJSON: {},

      query: JSON.parse(query),

      openDialog: false,
      dialogFormModel: {
        app: null,
        queryId: null
      }
    }
  },

  watch: {
    dashboardAsString (newValue, prevValue) {
      if (newValue === prevValue) return
      this.parseJSON(newValue, 'dashboard') // TODO: debounce
    },

    resultsAsString (newValue, prevValue) {
      if (newValue === prevValue) return
      this.parseJSON(newValue, 'results') // TODO: debounce
    }
  },

  computed: {
    context () {
      return {
        applicationId: 'playground',
        baseURL: window.envmap.VUE_APP_AGILIS_APP_DEFAULT_ENDPOINT,
        dashboard: this.dashboard,
        query: this.query
      }
    },

    queryId () {
      return metric => {
        return metric.query || this.context.dashboard.metrics.default.query
      }
    },

    resultsSet () {
      return this.results
    },

    dialogForm () {
      const appOptions = Object.entries(Configuration.getApplications())
        .filter(([appId, app]) => !!app.trackerTypes)
        .map(([appId, app]) => ({ text: app.name, id: appId }))

      return {
        formRows: [
          { cols: ['app'] },
          { cols: ['queryId'] }
        ],
        fields: {
          app: {
            id: 'app',
            type: 'select',
            label: 'Application',
            options: appOptions,
            outValue: 'app',
            outValueExpr: '$id',
            required: true
          },
          queryId: {
            id: 'queryId',
            type: 'select',
            label: 'Query',
            outValue: 'queryId',
            outValueExpr: '$id',
            required: true,
            propsWhen: {
              disabled: model => !model.app,
              options: model => {
                const app = Configuration.getApplications()[model.app]
                const query = app?.query || {}

                return Object.entries(query)
                  .map(([queryId]) => ({ id: queryId, text: queryId }))
              }
            }
          }
        }
      }
    }
  },

  methods: {
    parseJSON (newValue, key) {
      try {
        this[key] = JSON.parse(newValue)
        Vue.set(this.invalidJSON, key, false)
      } catch (e) {
        Vue.set(this.invalidJSON, key, true)
      }
    },

    async loadFromConfig () {
      const { app, queryId } = this.dialogFormModel

      this.query = {
        [queryId]: Configuration.getApplications()[app].query[queryId]
      }

      await this.fireQuery(app, queryId)

      // Apply default dashboard
      this.applyDefaultDashboard(queryId)

      // Close dialog
      this.openDialog = false
    },

    async fireQuery (app, queryId) {
      const queryUrl = this.$axios.agilisUrlQuery(app, queryId)
      try {
        const response = (await this.$axios.post(
          queryUrl,
          { filterTerms: [] },
          this.$axios.agilisRequestConfig(queryUrl)
        ))

        this.resultsAsString = JSON.stringify({ [queryId]: response.data.items }, null, 2)
      } catch (error) {
        this.notifyError(error)
      }
    },

    applyDefaultDashboard (queryId) {
      this.dashboardAsString = JSON.stringify({
        metrics: {
          default: {
            query: queryId
          },
          'defaultTable': {
            'id': 'defaultTable',
            'name': 'DataTable',
            'type': 'table'
          }
        },
        layout: [
          { cols: ['defaultTable'] }
        ]
      }, null, 2)
    }
  }
}
